<template>
  <div class="neu-cards-slider-general">
  <b-row class="centered d-flex neu-cards-slider-general-funct">
    <base-modal ref="signUpModal" v-if="signUpVisible" v-model="signUpVisible" :title="$t('sign-up')" hideClose> 
      <patient-signup-form :callback="() => { signUpVisible = false }"/>
    </base-modal>
    <b-col v-if="blackTitle != null || hasHeadingSlot" cols="12" class="text-center pt-lg-0 d-inline-block">
      <div class="my-auto" v-if="!hasHeadingSlot">
        <h2 v-if="blackTitle" class="mobile-font mx-3 mx-md-0 mt-5 mt-md-0 my-md-5" :class="{'my-5': typeTitle != 'principal' && !$uiHelpers.isFullMobile}" style="display: inline-block;font-size:35px;padding-top">{{ blackTitle }}</h2>  
        <br v-if="typeTitle==='principal'"><h3 v-if="title != null" class="mobile-font" :class="{'my-5': !$uiHelpers.isFullMobile}" style="font-size:35px;display: inline-block"> {{ title }}</h3>
        <h4 v-if="subtitle != null" class="mobile-font" :class="{'my-2 mx-5': !$uiHelpers.isFullMobile, 'mx-2': !$uiHelpers.isFullMobile}" style="font-size:25px;display: inline-block;color: #3238C4"> {{ subtitle }}</h4>
      </div>
      <div v-else>
        <slot name="heading"></slot>
      </div>
    </b-col>
        <carousel2 class="d-none d-touch-screens-block" :cards="cards.filter(e => (!e.inMx && (e.es || true) === true) || (inMx && e.mx === true))" :type="type" :iconColor="iconsColor"></carousel2>
         <carousel-3d class="d-block d-touch-screens-none mb-5 mb-md-0" :height="350" :border="0">
            <slide style="background-color:transparent"  v-for="(professional, i) in cards.filter(e => (!inMx && (e.es || true) === true) || (inMx && e.mx === true))" :index="i" :key="i">
                      <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                    <!-- <img :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="slide.src"> -->
                    <!-- <neu-card-function :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"  :src="professional.src" :title="professional.title" :subtitle="professional.subtitle" :titleLines="2" :subtitleLines="2"></neu-card-function> -->
                    <neu-card-general :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" v-if="professional.type == 0" :src="professional.src" :title="professional.title" :subtitle="professional.subtitle" :titleLines="1" :subtitleLines="1"></neu-card-general>
                    <neu-card-general :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" v-if="professional.type == 2" :src="professional.src" :link="professional.link" :title="professional.title" :titleLines="professional.titleLines" :iconColor="iconsColor"></neu-card-general>
                    <neu-card-big-text :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" v-if="professional.type == null" :src="professional.src" :title="professional.title" :subtitle="professional.subtitle" :titleLines="professional.titleLines" :subtitleLines="professional.subtitleLines" :iconColor="iconsColor"></neu-card-big-text>                   
                  </template>

            </slide>
        </carousel-3d>
  </b-row>
      </div>
</template>

<script>
import NeuCard from './NeuCardFunctions.vue'
import BaseModal from '../BaseModal.vue'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import { inMx } from '@/helpers/global.helpers'

export default {
  name: 'neu-cards-slider2',
  components: {
    NeuCard,
    'carousel': () => import('@/components/base/carousel/Carousel'),
    'carousel2': () => import('@/components/base/carousel/Carousel2'),
    'carousel-slide': () => import('@/components/base/carousel/CarouselSlide'),
    'patient-signup-form': () => import('@/components/forms/PatientSignupForm'),
    'neu-card-function': () => import('@/components/base/ui/NeuCardFunctions'),
    'neu-card-general': () => import('@/components/base/ui/NeuCardGeneral'),
    'neu-card-function-icon': () => import('@/components/base/ui/NeuCardFunctionsJustIcon'),
    'neu-card-big-text': () => import('@/components/base/ui/NeuCardFunctionsBigText'),
     Carousel3d,
    Slide,
    BaseModal

  },
  data () {
    return {
      slide: 0,
      signInVisible: false,
      signUpVisible: false,
      windowWidth: window.innerWidth,
      cardDivided: (window.innerWidth >= 1024 && window.innerWidth <= 1322) ? this.chunkArray(this.cards, 2) : this.chunkArray(this.cards, 3),
      sliding: null,
			inMx
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    chunkArray (myArray, size) {
          var index = 0
          var arrayLength = myArray.length
          var tempArray = []
          var myChunk = []
          for (index = 0; index < arrayLength; index += size) {
              myChunk = myArray.slice(index, index + size)
              // Do something if you want with the group
              tempArray.push(myChunk)
          }

          return tempArray
    }
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    type: {
        type: String,
        require: false
      },
    title: {
      type: String,
      required: false
    },
    typeTitle: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
     blackTitle: {
      type: String,
      required: false
    },
    subtitleLines: Number,
    titleLines: Number,
    iconsColor: {
      type: String,
      required: false
    }
  },
	computed: {
		hasHeadingSlot () {
			return !!this.$slots.heading
		}
	}
}
</script>

<style lang="scss">
@import '../../../../static-appopensalud/css/scss/ui.scss';
.mobile-font{
 @include tablets {
    font-size: 20px !important;
  }
  @include mobile {
    font-size: 23px !important;
    padding-right: 1rem;
    padding-left: 1rem;
  }
}
/* .section {
  @include desktop {
    padding-right: 5rem !important;
    padding-left: 5rem !important;  
}
  @include desktop-sm {
    padding-right: 5rem !important;
    padding-left: 5rem !important;  
  }
  @include tablets {
    padding-right: 5rem !important;
    padding-left: 5rem !important;  
  }
  @include mobile {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
} */
  .neu-cards-slider-general {
    .d-touch-screens-block{
  @media only screen and (min-width: 1367px) {
    display: block !important;
  }}

    .d-touch-screens-none{
      @media only screen and (min-width: 1367px) {
        display: none !important;
      }}
  @include desktop {
  .neu-cards-slider {

    .card-ctn {
      display: flex;
  @include mobile {
        // padding: 0 4rem !important;
        padding-right: 3rem !important;
        padding-left: 3rem !important;
      }
      @include desktop {
        &.less-cols {
          padding: 0 1rem !important;
        }
         @media screen and (min-width: 700px) and (max-width: 1550px) {
        padding: 0 2rem !important;
        } 
        padding: 0 4rem;
      }
    
      @include desktop-sm {
        padding: 0 2rem;
      }
     /*  @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        margin-right: 5rem;
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      } */

      .neu-card {
        display: flex;
        @include desktop {
          padding: 1rem;
          min-height: 300px;
          max-width: 350px;
          svg {
            width: 60%;
          }
        }
        @include desktop-sm {
          padding: 0rem;
          min-height: 300px;
          max-width: 250px;
        }

        /* @include tablets {
          padding: 4rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          width: 25%;
          margin-bottom: 3rem;
          min-height: 280px;
        }*/
      }
      .neu-card-rates {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 500px;
          max-width: 220px;
        }
        @include desktop-sm {
          padding: 0rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        /* @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }*/
      }
    }
  }
}
  @include mobile {
  .neu-cards-slider {

    .card-ctn {
      display: flex;
  @include mobile {
        // padding: 0 4rem !important;
        padding-right: 3rem !important;
        padding-left: 3rem !important;
        padding-bottom: 3rem !important;

      }

      .neu-card {
        display: flex;
      }
      .neu-card-rates {
        display: flex;
      }
    }
  }
}
}

  /* @include media(mobile, tablets) {
    .neu-cards-slider-general-funct {
      padding-right: 1.15rem !important;
      padding-left: 1.15rem !important;
    }
  } */
  
</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardsSlider2.vue